import axios from 'axios';

export async function uploadFile(file) {
  const formData = new FormData();
  const filename = file.name?.trim() || (file.type?.startsWith('image/')
    ? `image.${(file.type || 'image/jpeg').split('/')[1] || 'jpg'}`
    : 'file');
  formData.append('file', file, filename);
  const res = await axios.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const baseURL = (axios.defaults.baseURL || '').replace(/\/$/, '');
  return {
    url: `${baseURL}${res.data.url}`,
    name: res.data.name || file.name || '',
    type: res.data.type || file.type || '',
  };
}
